import { render } from "./B2bNewUserEntities.vue?vue&type=template&id=3c7f0016&scoped=true&lang=pug"
import script from "./B2bNewUserEntities.vue?vue&type=script&lang=js"
export * from "./B2bNewUserEntities.vue?vue&type=script&lang=js"

import "./B2bNewUserEntities.vue?vue&type=style&index=0&id=3c7f0016&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7f0016"]])

export default __exports__